/* Smith Art theme — light-touch enhancements only; the theme works without JS. */

document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".main-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("open");
    });
  }

  var sortSelect = document.querySelector("[data-sort-by]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Auto-submit cart quantity changes so totals stay accurate.
  document.querySelectorAll("[data-cart-qty]").forEach(function (input) {
    input.addEventListener("change", function () {
      var form = input.closest("form");
      if (form) form.submit();
    });
  });

  // Variant picker: reload with ?variant= so the enlarged image and
  // availability reflect the chosen work.
  document.querySelectorAll(".variant-picker select").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", sel.value);
      window.location.href = url.toString();
    });
  });

  // Two-step buy: "Check Availability" reveals the variant's real status
  // (available -> Add to Cart, sold -> reserved notice). Without JS the
  // normal Add to Cart button stays in place.
  var buyArea = document.querySelector(".buy-area[data-availability]");
  if (buyArea) {
    var checkBtn = buyArea.querySelector("[data-check-availability]");
    var statusEl = buyArea.querySelector("[data-availability-status]");
    var addBtn = buyArea.querySelector("[data-add-button]");
    addBtn.hidden = true;
    checkBtn.hidden = false;
    checkBtn.addEventListener("click", function () {
      checkBtn.disabled = true;
      checkBtn.textContent = "Checking availability\u2026";
      window.setTimeout(function () {
        checkBtn.hidden = true;
        statusEl.hidden = false;
        if (buyArea.getAttribute("data-availability") === "available") {
          statusEl.textContent = "Available for Order";
          statusEl.classList.add("is-available");
          addBtn.hidden = false;
          var note = buyArea.querySelector("[data-delivery-note]");
          if (note) {
            var fmt = function (d) {
              return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
            };
            var from = new Date();
            from.setDate(from.getDate() + 3);
            var to = new Date();
            to.setDate(to.getDate() + 5);
            note.querySelector("[data-delivery-dates]").textContent = fmt(from) + " \u2013 " + fmt(to);
            note.hidden = false;
          }
        } else {
          statusEl.textContent = "Reserved \u2014 no longer available";
          statusEl.classList.add("is-reserved");
        }
      }, 900);
    });
  }

  // Enquiry form: cap the message at a word limit with a live counter.
  var limited = document.querySelector("textarea[data-word-limit]");
  if (limited) {
    var limit = parseInt(limited.getAttribute("data-word-limit"), 10);
    var counter = document.querySelector("[data-word-count]");
    limited.addEventListener("input", function () {
      var words = limited.value.trim().split(/\s+/).filter(Boolean);
      if (words.length > limit) {
        limited.value = words.slice(0, limit).join(" ");
        words = words.slice(0, limit);
      }
      if (counter) {
        counter.hidden = false;
        counter.textContent = words.length + " / " + limit + " words";
      }
    });
  }
});
